// This file is AUTOGENERATED, do not edit it manually!!!

export const filters = {
    Activity_Text: 'Actividad',
    ActivityActualBilling: 'Actividad facturable',
    ActivityActualCompletionDateCondition_Text: 'Fecha real de finalización de la actividad',
    ActivityActualCost: 'Costo real de la actividad',
    ActivityActualGreaterThanEstimated_Text: 'Actividades subestimadas',
    ActivityActualHours: 'Horas reales de la actividad',
    ActivityActualLaborBilling: 'Mano de obra facturable real de la actividad ',
    ActivityActualLaborCost: 'Costo real de la mano de obra de la actividad',
    ActivityBillableHours: 'Horas facturables de la actividad',
    ActivityBilled: 'Actividad facturada',
    ActivityBilledLabor: 'Mano de obra facturada de la actividad',
    ActivityBilledPercentage: 'Actividad facturada, %',
    ActivityBudgetVariance: 'Varianza del presupuesto de la actividad',
    ActivityCreationDateCondition_Text: 'Fecha de creación de la actividad',
    ActivityCreator_Text: 'Creadores de la actividad',
    ActivityCreatorCondition_Empty_Text: 'Sistema',
    ActivityCreatorCondition_Text: 'Creador de la actividad',
    ActivityCustomFieldCondition_Text: 'Campos personalizados de la actividad',
    ActivityDuration: 'Duración de la actividad',
    ActivityEACBillableExpenses: 'Gastos facturables EAC de la actividad',
    ActivityEACBilling: 'Facturación EAC de la actividad',
    ActivityEACCost: 'Costo EAC de la actividad',
    ActivityEACExpenses: 'Gastos EAC de la actividad',
    ActivityEACLaborBilling: 'Mano de obra facturable EAC de la actividad',
    ActivityEACLaborCost: 'Costo de mano de obra EAC de la actividad',
    ActivityEACNonBillableExpenses: 'Gastos no facturables EAC de la actividad',
    ActivityEndDateCondition_Text: 'Fecha de finalización de la actividad',
    ActivityEstimatedExpensesAmount: 'Gastos ETC de la actividad',
    ActivityEstimatedExpensesBillableAmount: 'Gastos facturables ETC de la actividad',
    ActivityEstimatedExpensesNonBillableAmount: 'Gastos no facturables ETC de la actividad',
    ActivityEstimatedHours: 'Horas estimadas de la actividad',
    ActivityETCBilling: 'Facturación ETC de la actividad',
    ActivityETCCost: 'Costo ETC de la actividad',
    ActivityETCLaborBilling: 'Mano de obra facturable ETC de la actividad',
    ActivityETCLaborCost: 'Costo de mano de obra ETC de la actividad',
    ActivityExpectedProfit: 'Ganancia esperada de la actividad',
    ActivityExpectedProfitPercentage: 'Ganancia esperada de la actividad, %',
    ActivityExpensesAmount: 'Gastos reales de la actividad',
    ActivityExpensesBillableAmount: 'Gastos facturables reales de la actividad',
    ActivityExpensesBilledAmount: 'Gastos facturados de la actividad',
    ActivityExpensesNonBillableAmount: 'Gastos no facturables reales de la actividad',
    ActivityHealthCondition_Text: 'Salud de la actividad',
    ActivityHealthTypes: 'Salud de la actividad',
    ActivityIsMilestone: 'La actividad es un hito',
    ActivityNonBillableHours: 'Horas no facturables de la actividad',
    ActivityProcessCondition_Text: 'Progreso de la actividad',
    ActivityProfit: 'Ganancia de la actividad',
    ActivityProfitPercentage: 'Ganancia de la actividad, %',
    ActivityProgress_Text: 'Progreso de la actividad',
    ActivityStartDateCondition_Text: 'Fecha de inicio de la actividad',
    ActivityStatusCondition_Text: 'Estatus de la actividad',
    ActivityTotalBudget: 'Presupuesto total de la actividad',
    ActivityTypeCondition_Text: 'Tipo de actividad:',
    ActivityTypes_Issue: 'Problema',
    ActivityTypes_Request: 'Solicitud',
    ActivityTypes_Task: 'Tarea',
    ActivityTypesCondition_Text: 'Tipos de actividad',
    ActualCompletionDate_Text: 'Fecha real de finalización',
    add_filters: 'Agregar filtros',
    AdvancedFilterTooltipContent_Text: 'Haz clic aquí para ver todas las opciones de filtrado posibles',
    AdvancedFilterTooltipTitle_Text: 'Filtros avanzados',
    AllActivities_Text: 'Actividad',
    Apply_Text: 'Aplicar',
    AssigneeCondition_Text: 'Responsables de la actividad',
    AssigneeOption_Text: 'Responsables de la actividad',
    AssigneeTeamCondition_Entity: 'equipos',
    AssigneeUserCondition_Empty_Text: 'Sin responsables',
    AssigneeUserCondition_Entity: 'responsables de la actividad',
    BoolCustomField_No_Text: 'No',
    BoolCustomField_NotSelected_Text: 'No seleccionado',
    BoolCustomField_Yes_Text: 'Sí',
    BudgetAndCosts_Filters_Group: 'Presupuesto y costos',
    CategoriesCondition_Text: 'Categorías',
    CategoryCondition_Empty_Text: 'Sin categoría',
    CategoryCondition_Entity: 'categorías',
    CategoryCondition_Text: 'Categoría',
    Clear_All_Text: 'Limpiar todos los filtros',
    CompletedStatus_Text: 'Completado',
    constraints_filters_group: 'Restricciones',
    ContainMore_Text: 'Hay más resultados, sigue escribiendo...',
    CreationDate_Text: 'Fecha de creación',
    CustomerCondition_Empty_Text: 'Sin cliente',
    CustomerCondition_Entity: 'clientes',
    CustomerCondition_Text: 'Clientes',
    CustomFieldsFilters_Group: 'Campos personalizados',
    DraftCondition_Text: 'Borradores',
    DraftStatus_Text: 'Borradores',
    EndDate_Text: 'Fecha de finalización',
    FilterByKeyword_Text: 'Filtrar por palabra clave',
    FilterByPeriod_Text: 'Filtrar por período',
    FilterByTimeframe_Text: 'Filtrar por intervalo de tiempo',
    FilterTabs_Tab1: 'Estatus',
    FilterTabs_Tab2: 'Recursos y restricciones',
    FilterTabs_Tab3: 'Salud y progreso',
    FilterTabs_Tab4: 'Proyectos, clientes y más',
    FilterTabs_Tab5: 'Campos personalizados',
    Followed: 'Siguiendo',
    FollowedByMe_Text: 'Actividades seguidas por mí',
    From_Text: 'de',
    general: 'General',
    HealthCondition_Text: 'Salud',
    HealthItemType_Bad: 'Problema',
    HealthItemType_Good: 'Bueno',
    HealthItemType_Medium: 'En riesgo',
    HealthItemType_NotCalculated: 'No calculado',
    HealthTooltip_Text: 'La salud es un índice calculado que muestra qué tan bien está yendo un proyecto o actividad',
    HealthTooltipLink_Text: 'Ver más en nuestra ayuda en línea',
    HoursCondition_Text: 'Tiempo',
    HoursFilters_Group: 'Tiempo',
    HoursLeft: 'Horas restantes',
    InProgressStatus_Text: 'En progreso',
    InThePast: 'En el pasado',
    InvalidDate: 'La fecha debe tener el formato \'{0}\'.',
    Issue_Text: 'Problema',
    KeepTyping_Text: 'Sigue escribiendo...',
    ListCustomFieldCondition_Empty_Text: 'No seleccionado',
    ManualRange: 'Rango de fechas especificado...',
    Me: 'Yo',
    Menu_Dates: 'Fechas',
    Milestone_Text: 'Hito',
    MoneyCondition_Text: 'Dinero',
    More_Text: 'Más',
    MultiSelectCustomFieldCondition_Empty_Text: 'No seleccionado',
    NextMonth: 'Próximo mes',
    NextWeek: 'Próxima semana',
    no_filters: 'No hay filtros para mostrar',
    NoCategory: 'Sin categoría',
    NoMatch_Text: 'Lo sentimos, no se encontró nada',
    OnHoldStatus_Text: 'En espera',
    PeopleCondition_Text: 'Personas',
    PinTooltip_Text: 'Fijar',
    Portfolio_Status_Text: 'Estatus del portafolio',
    PortfolioCondition_Empty_Text: 'Sin portafolio',
    PortfolioCondition_Entity: 'portafolios',
    PortfolioCondition_Text: 'Portafolios',
    PortfolioCreator_Text: 'Creadores del portafolio',
    PortfolioCreatorCondition_Text: 'Creador del portafolio',
    PortfolioManager_Text: 'Gerentes del portafolio',
    PortfolioManagerCondition_Text: 'Gerente del portafolio',
    PreviousMonth: 'Mes anterior',
    PreviousWeek: 'Semana anterior',
    PreviousYear: 'Año anterior',
    PriorityCondition_Text: 'Prioridades',
    Progress_Filters_Group: 'Progreso',
    ProgressCondition_Entity: 'Progreso: ',
    ProgressCondition_Text: 'Progreso',
    Project_Text: 'Proyecto',
    ProjectActualBilling: 'Facturación real del proyecto',
    ProjectActualCompletionDateCondition_Text: 'Fecha de finalización real del proyecto',
    ProjectActualCost: 'Costo real del proyecto',
    ProjectActualGreaterThanEstimated_Text: 'Proyectos subestimados',
    ProjectActualHours: 'Horas reales del proyecto',
    ProjectActualLaborBilling: 'Mano de obra facturable real del proyecto',
    ProjectActualLaborCost: 'Costo de mano de obra real del proyecto',
    ProjectBillableHours: 'Horas facturables del proyecto',
    ProjectBilled: 'Proyecto facturado',
    ProjectBilledLabor: 'Mano de obra facturada del proyecto',
    ProjectBilledPercentage: 'Proyecto facturado, %',
    ProjectBudgetVariance: 'Variación del presupuesto del proyecto',
    ProjectCondition_EmptyText: 'Ningún proyecto seleccionado',
    ProjectCondition_Entity: 'proyectos',
    ProjectCondition_Text: 'Proyectos',
    ProjectCostExceedBudget_Text: 'Proyectos sobrepresupuestados',
    ProjectCreationDateCondition_Text: 'Fecha de creación del proyecto',
    ProjectCreator_Text: 'Creadores del proyecto',
    ProjectCreatorCondition_Text: 'Creador del proyecto',
    ProjectCustomFieldCondition_Text: 'Campos personalizados del proyecto',
    ProjectDuration: 'Duración del proyecto',
    ProjectEACBillableExpenses: 'Gastos facturables EAC del proyecto',
    ProjectEACBilling: 'Facturación EAC del proyecto',
    ProjectEACCost: 'Costo EAC del proyecto',
    ProjectEACExpenses: 'Gastos EAC del proyecto',
    ProjectEACLaborBilling: 'Mano de obra facturable EAC del proyecto',
    ProjectEACLaborCost: 'Costo de mano de obra EAC del proyecto',
    ProjectEACNonBillableExpenses: 'Gastos no facturables EAC del proyecto',
    ProjectEndDateCondition_Text: 'Fecha de finalización del proyecto',
    ProjectEstimatedExpensesAmount: 'Gastos ETC del proyecto',
    ProjectEstimatedExpensesBillableAmount: 'Gastos facturables ETC del proyecto',
    ProjectEstimatedExpensesNonBillableAmount: 'Gastos no facturables ETC del proyecto',
    ProjectEstimatedHours: 'Horas estimadas del proyecto',
    ProjectETCBilling: 'Facturación ETC del proyecto',
    ProjectETCCost: 'Costo ETC del proyecto',
    ProjectETCLaborBilling: 'Mano de obra facturable ETC del proyecto',
    ProjectETCLaborCost: 'Costo de mano de obra ETC del proyecto',
    ProjectExpectedProfit: 'Ganancia esperada del proyecto',
    ProjectExpectedProfitPercentage: 'Ganancia esperada del proyecto, %',
    ProjectExpensesAmount: 'Gastos reales del proyecto',
    ProjectExpensesBillableAmount: 'Gastos facturables reales del proyecto',
    ProjectExpensesBilledAmount: 'Gastos facturados del proyecto',
    ProjectExpensesNonBillableAmount: 'Gastos no facturables reales del proyecto',
    ProjectHealthCondition_Text: 'Salud del proyecto',
    ProjectHealthTypes: 'Salud del proyecto',
    ProjectManager_Text: 'Gerentes del proyecto',
    ProjectManagerCondition_Text: 'Gerente del proyecto',
    ProjectMemberCondition_Text: 'Miembro del proyecto',
    ProjectNonBillableHours: 'Horas no facturables del proyecto',
    ProjectPriorityCondition_Text: 'Prioridad del proyecto',
    ProjectPriorityCondition_Text_Template: 'Proyectos con prioridad %s',
    ProjectProcessCondition_Text: 'Progreso del proyecto',
    ProjectProfit: 'Ganancia del proyecto',
    ProjectProfit_Text: 'Proyectos con pérdida financiera',
    ProjectProfitPercentage: 'Ganancia del proyecto, %',
    ProjectProgress_Text: 'Progreso del proyecto',
    ProjectsAndTasksList_Title: 'Proyectos y tareas',
    ProjectsCustomersAndMore_Filters_Group: 'Proyectos, clientes y más',
    ProjectStartDateCondition_Text: 'Fecha de inicio del proyecto',
    ProjectStatusCondition_Text: 'Estatus del proyecto',
    ProjectTotalBudget: 'Presupuesto total del proyecto',
    QuickFilterWatermark: 'Filtrar por...',
    range_condition_text: 'Rango',
    Request_Text: 'Solicitud',
    resource_types_condition_text: 'Recursos',
    resource_types_planning_condition_text: 'Proyectos con recursos',
    resource_types_unnamed_label: 'Recursos sin nombre',
    resource_types_user_label: 'Usuarios',
    ResourceRequestApprover_Text: 'Aprobador de la solicitud de recurso',
    ResourceRequestCreator_Text: 'Creador de la solicitud de recurso',
    ResourceRequestStatuses_Approved: 'Aprobado',
    ResourceRequestStatuses_Rejected: 'Rechazado',
    ResourceRequestStatuses_WaitingForApproval: 'Esperando aprobación',
    ResourceRequestStatuses_WithoutRequest: 'Sin solicitud',
    ResourceRequestStatusFilter_Text: 'Estatus de la solicitud de recurso',
    resources_filters_group: 'Recursos',
    resources_requests_filters_group: 'Solicitudes de recursos',
    ResourcesAndConstraints_Filters_Group: 'Recursos y restricciones',
    roles_condition_text: 'Roles',
    RollBack_Text: 'Volver a los filtros anteriores',
    SaveFilters_Title: 'Filtros guardados',
    set_filters: 'Establecer filtros usando el',
    set_filters_part2: 'icono',
    skills_condition_text: 'Habilidades',
    StartDate_Text: 'Fecha de inicio',
    Statuses_Filters_Group: 'Estatus',
    StatusesCountFormat: '1#{0} estatus#{0} estatuses',
    Task_Text: 'Tarea',
    TaskCondition_Entity: 'actividades',
    TaskCondition_Text: 'Actividad',
    TaskCostExceedBudget_Text: 'Actividades con presupuesto excedido',
    TaskPriorityCondition_Entity: 'prioridades de actividad',
    TaskPriorityCondition_Text: 'Prioridad de actividad',
    TaskPriorityCondition_Text_Template: 'Actividades con prioridad %s',
    TasksAssignedToMilestone_Text: 'Actividad asignada al hito',
    teams_condition_text: 'Equipos',
    TemplateCondition_Text: 'Plantillas',
    TemplateStatus_Text: 'Plantillas',
    ThisMonth: 'Este mes',
    ThisWeek: 'Esta semana',
    ThisYear: 'Este año',
    To_Text: 'a',
    Today: 'Hoy',
    TypesCondition_Text: 'Tipos',
    UnpinTooltip_Text: 'Desanclar',
    users_condition_text: 'Usuarios',
    Yesterday: 'Ayer',
};
